import { usePrevious } from './use-previous.hook';

export function useIsChanged<T>(value: T, initialValue?: T) {
  const prevValue = usePrevious<T>(value, initialValue);
  return prevValue !== value;
}
